import React, { useState } from 'react';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const LeoSuggestionBar = ( { uid, user, innerRef, contacts, opps, loans, obj, objType } ) => {
    return (
        <Row ref={innerRef} className='tf-leo-suggestion-bar py-2'>
            <Col>Ai Stuff</Col>
        </Row>
    );                    
};

const mapProps = ( state ) => ( {
    uid: state.user.email,
    user: state.user,
    contacts: state.contacts.byId,
    opps: state.leadopps.byId,
    loans: state.loans.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( LeoSuggestionBar );